var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29167 3.625H17.7083C20.0095 3.625 21.875 5.49048 21.875 7.79167C21.875 10.0929 20.0095 11.9583 17.7083 11.9583H7.29167C4.99048 11.9583 3.125 10.0929 3.125 7.79167C3.125 5.49048 4.99048 3.625 7.29167 3.625ZM7.29167 9.875C8.44226 9.875 9.375 8.94226 9.375 7.79167C9.375 6.64107 8.44226 5.70833 7.29167 5.70833C6.14107 5.70833 5.20833 6.64107 5.20833 7.79167C5.20833 8.94226 6.14107 9.875 7.29167 9.875Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29167 14.041H17.7083C20.0095 14.041 21.875 15.9065 21.875 18.2077C21.875 20.5089 20.0095 22.3743 17.7083 22.3743H7.29167C4.99048 22.3743 3.125 20.5089 3.125 18.2077C3.125 15.9065 4.99048 14.041 7.29167 14.041ZM17.7083 20.291C18.8589 20.291 19.7917 19.3583 19.7917 18.2077C19.7917 17.0571 18.8589 16.1243 17.7083 16.1243C16.5577 16.1243 15.625 17.0571 15.625 18.2077C15.625 19.3583 16.5577 20.291 17.7083 20.291Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.0b5e22c5eaad2d6dbf4fd515f6130f80.svg";
export { ForwardRef as ReactComponent };